<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <div class="kt-form" ref="form" @submit.prevent="onSubmit($event)">
      <form class="kt-form">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">{{ this.$route.meta.breadcrumb }}</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">รหัสตัวแทนจำหน่าย:</label>
                  <input
                    id="agentCode"
                    name="agentCode"
                    v-model="agentCode"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="รหัสตัวแทนจำหน่าย"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">ชื่อตัวแทนจำหน่าย:</label>
                  <input
                    id="agentName"
                    name="agentName"
                    v-model="holdTime"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อตัวแทนจำหน่าย"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>ที่อยู่:</label>
                  <input
                    id="adress"
                    name="adress"
                    v-model="adress"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อตัวแทนจำหน่าย"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>เบอร์โทร:</label>
                  <input id="tel" name="tel" v-model="tel" type="text" maxlength="450" class="form-control" placeholder="เบอร์โทร" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>Email:</label>
                  <input id="email" name="email" v-model="email" type="text" maxlength="450" class="form-control" placeholder="เบอร์โทร" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label>Latitude:</label>
                  <input id="lat" name="lat" v-model="lat" type="text" maxlength="450" class="form-control" placeholder="Latitude" />
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>Longitude:</label>
                  <input id="lng" name="lng" v-model="lng" type="text" maxlength="450" class="form-control" placeholder="Longitude" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label
                    >รูปภาพ:<span class="text-sm text-danger" style="font-size:small">
                      (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)</span
                    ></label
                  >
                  <button
                    type="button"
                    class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2 col-lg-2 col-md-2 .col-sm-2 col-xs-2"
                    id="uploader-btn"
                  >
                    <i class="flaticon-upload-1"></i>รูป
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="checkbox" class="form-check-input" name="status" id="status" value="checkedValue" checked />
                      เปิดใช้งาน
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="la la-close"></i> ปิดหน้าต่าง</button>
          <button type="submit" class="btn btn-primary"><i class="la la-save"></i> บันทึกข้อมูล</button>
        </div>
      </form>
    </div>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      // userName: null,
      // password: null,
      // confirmPassword: null,
      // email: null,
      // givenName: null,
      // familyName: null,
      // position: null,
      // phoneNumber: null,
      // roleName: null
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#agentCreateModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      axios
        .post("/Api/Users/Create", {
          userName: this.userName,
          password: this.password,
          confirmPassword: this.confirmPassword,
          email: this.email,
          givenName: this.givenName,
          familyName: this.familyName,
          position: this.position,
          phoneNumber: this.phoneNumber,
          roleName: this.roleName,
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              $("#holdCreateModal").modal("hide");
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $("#dateType").select2({
      tags: true,
      placeholder: "กรุณาเลือก",
      allowClear: true,
    });

    // set validation rules
    $("#agentCreateModal form").validate({
      // rules: {
      //   userName: "required",
      //   email: {
      //     required: true,
      //     email: true
      //   },
      //   password: {
      //     required: true,
      //     minlength: 6
      //   },
      //   confirmPassword: {
      //     equalTo: "#password"
      //   },
      //   givenName: "required",
      //   familyName: "required",
      //   phoneNumber: "required"
      // },
      // messages: {
      //   userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
      //   email: {
      //     required: "กรุณากรอกอีเมล",
      //     email: "กรุณากรอกอีเมลให้ถูกต้อง"
      //   },
      //   password: {
      //     required: "กรุณากรอกรหัสผ่าน",
      //     minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
      //   },
      //   confirmPassword: {
      //     equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
      //   },
      //   givenName: "กรุณากรอกชื่อ",
      //   familyName: "กรุณากรอกชื่อสกุล",
      //   phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
      // }
    });
    $("#agentCreateModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Agent/AgentCreate.vue